/** @format */

import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';

const initialState = {
  // All dashboards fetched so far, keyed by dashboard id
  byId: {},
  loading: false,
  error: null
};

const slice = createSlice({
  name: 'dashboards',
  initialState,
  reducers: {
    getDashboardById(state) {
      state.loading = true;
      state.error = null;
    },
    saveDashboard(state, action) {
      const { dashboardId, data } = action.payload;
      state.byId[dashboardId] = data;
      state.loading = false;
    },
    getDashboardByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    removeDashboard(state, action) {
      const { dashboardId } = action.payload;
      delete state.byId[dashboardId];
    },
    clearDashboards(state) {
      state.byId = {};
    }
  }
});

export const reducer = slice.reducer;

export const { saveDashboard, removeDashboard, clearDashboards } = slice.actions;

// Fetch a dashboard and keep it in the store (uses cache unless forceRefresh)
export const getDashboardById =
  ({ dashboardId, forceRefresh = false }) =>
  async (dispatch, getState) => {
    const { getDashboardById, saveDashboard, getDashboardByIdFailure } = slice.actions;

    const cached = getState().dashboards.byId[dashboardId];
    if (cached && !forceRefresh) return cached;

    try {
      dispatch(getDashboardById());
      const response = await axios.get(`${ENDPOINTS.GET_DASHBOARD_ENDPOINT}${dashboardId}`);
      const { data } = response;
      dispatch(saveDashboard({ dashboardId, data }));
      return data;
    } catch (err) {
      dispatch(getDashboardByIdFailure(err));
    }
  };

// Selectors
export const selectAllDashboards = state => state.dashboards.byId;
export const selectDashboardById = dashboardId => state => state.dashboards.byId[dashboardId];

export default slice;
